<template>
  <div id="giftcard">
    <div class="w-100 container-giftcard">
      <headGiftCard></headGiftCard>

      <div class="main-content">
        <div class="d-flex flex-column align-items-center justify-content-center">
          <div :class="isPhone ? 'merriweather-reg-20 text-center' : 'merriweather-reg-26'">Offrez un cadeau</div>
          <div :class="isPhone ? 'merriweather-reg-28 text-center' : 'merriweather-reg-40'">qui a du sens</div>
        </div>
        <section id="section-sejour" class="mb-4 w-100">
          <div id="sejour" class="row align-items-center">
            <div id="picture-sejour-container" class="col-md-6">
              <img class="img-fluid" id="picture-sejour" src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/carte_cadeau_img_1.png" v-set-alt data-aos="fade-left" data-aos-duration="1000">
            </div>
            <div class="col-md-6 sejour-text mt-3" data-aos="fade-left" data-aos-duration="1000">
              <div class="reassurance-grid">
                <!-- Row 1 left: E-carte disponible immédiatement — lightning bolt -->
                <div class="reassurance-item rg-left rg-top">
                  <span class="reassurance-icon" aria-hidden="true">
                    <i class="fa-solid fa-bolt reassurance-fa-icon"></i>
                  </span>
                  <div>
                    <div class="reassurance-title">E-carte disponible immédiatement</div>
                    <div class="reassurance-desc">Envoyée instantanément par e-mail et utilisable dès sa réception.</div>
                  </div>
                </div>
                <!-- Row 1 right: Valable 2 ans — calendar -->
                <div class="reassurance-item rg-right rg-top">
                  <span class="reassurance-icon" aria-hidden="true">
                    <i class="fa-solid fa-calendar-days reassurance-fa-icon"></i>
                  </span>
                  <div>
                    <div class="reassurance-title">Valable 2 ans</div>
                    <div class="reassurance-desc">Le bénéficiaire réserve son séjour aux dates de son choix, selon ses envies.</div>
                  </div>
                </div>
                <!-- Row 2 left: Applicable sur toutes les réservations — check circle -->
                <div class="reassurance-item rg-left rg-mid">
                  <span class="reassurance-icon" aria-hidden="true">
                    <i class="fa-solid fa-house reassurance-fa-icon"></i>
                  </span>
                  <div>
                    <div class="reassurance-title">Applicable sur toutes les réservations</div>
                    <div class="reassurance-desc">350+ hébergements de charme éco-responsables sélectionnés partout en France.</div>
                  </div>
                </div>
                <!-- Row 2 right: Envoi différé possible — clock -->
                <div class="reassurance-item rg-right rg-mid">
                  <span class="reassurance-icon" aria-hidden="true">
                    <i class="fa-solid fa-clock reassurance-fa-icon"></i>
                  </span>
                  <div>
                    <div class="reassurance-title">Envoi différé possible</div>
                    <div class="reassurance-desc">Programmez l'envoi au jour souhaité — anniversaire, Noël, fête des mères…</div>
                  </div>
                </div>
                <!-- Row 3 left: À chaque occasion — gift box -->
                <div class="reassurance-item rg-left rg-bottom">
                  <span class="reassurance-icon" aria-hidden="true">
                    <i class="fa-solid fa-gift reassurance-fa-icon"></i>
                  </span>
                  <div>
                    <div class="reassurance-title">À chaque occasion, sa carte cadeau</div>
                    <div class="reassurance-desc">Pour Noël, un anniversaire, un mariage, la fête des mères ou simplement pour faire plaisir, offrez une évasion éco-chic.</div>
                  </div>
                </div>
                <!-- Row 3 right: Montant libre — coin/dollar circle -->
                <div class="reassurance-item rg-right rg-bottom">
                  <span class="reassurance-icon" aria-hidden="true">
                    <i class="fa-solid fa-circle-dollar-to-slot reassurance-fa-icon"></i>
                  </span>
                  <div>
                    <div class="reassurance-title">Montant libre</div>
                    <div class="reassurance-desc">Choisissez le montant qui vous convient, de 100 € à 1 000 €.</div>
                  </div>
                </div>
              </div>
              <div :class="isPhone ? 'w-100 d-flex justify-content-center px-4 mt-3' : 'btn btn-durable border-deb pl-0 mt-3 d-flex justify-content-center w-100'">
                <a class="hortense-btn-primary btn-fid mb-4" @click="goToPaymentPage">Offrir une évasion éco-chic</a>
              </div>
            </div>
          </div>
        </section>

        <div class="collections-overview-container w-100 mb-5">
          <ExperienceCollections :user="user" :redirectionLink="'/reservation-hotel'" />
        </div>

        <section id="section-why-and-enterprise" class="row mb-4">
          <div class="col-lg-6 col-md-12">
            <div id="picture-why-gift-card-container">
              <img class="img-fluid" id="o-hortense-pourquoi" src="../../images/icotype.svg" v-set-alt data-aos="zoom-out" data-aos-duration="1000">
              <img class="img-fluid w-100" data-aos="fade-right" data-aos-duration="1000" id="picture-why-gift-card" src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/carte_cadeau_main.png" v-set-alt>
            </div>
            <div id="description-1" data-aos="fade-left" data-aos-duration="1000" :class="isPhone ? 'pt-3' : ''">
              <h3 :class="isPhone ? 'merriweather-reg-20 text-center' : 'merriweather-reg-26'">Pourquoi offrir une carte cadeau Hortense ?</h3>
              <ul class="raleway-reg-p16 pl-3 pourquoi-li">
                <li>Des lieux d'exception partout en France</li>
                <li>Des hébergements sélectionnés selon 150 critères d'éco-responsabilité.</li>
                <li>Un programme de fidélité qui couvre vos proches de cadeaux</li>
                <li>Une carte cadeau avec possibilité d’envoi différé : payez aujourd’hui et offrez-la au moment de votre choix.</li>
              </ul>
              <div :class="isPhone ? 'w-100 d-flex justify-content-center px-4': 'btn btn-durable border-deb'">
                <a class="hortense-btn-primary btn-fid mb-4" @click="goToPaymentPage">OFFRIR UNE CARTE CADEAU</a>
              </div>
            </div>
          </div>
          <div id="entreprise-or-ce text-center" class="col-lg-6 col-md-12">
            <div id="picture-enterprise-ce-container" data-aos="fade-left" data-aos-duration="1000">
              <img class="img-fluid" id="o-hortense-entreprise-ce" src="../../images/icotype.svg" v-set-alt data-aos="zoom-out" data-aos-duration="1000">
              <img class="img-fluid mt-0 w-100" id="picture-enterprise-ce" src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/carte+cadeau+voyage.webp" v-set-alt>
            </div>
            <div id="description-2" data-aos="fade-left " data-aos-duration="1000" :class="isPhone ? 'pt-3' : ''">
              <h3 :class="isPhone ? 'merriweather-reg-20 text-center' : 'merriweather-reg-26'">Comment fonctionne la carte cadeau ?</h3>
              <ul class="raleway-reg-p16 pl-3 pourquoi-li">
                <li>La carte cadeau est disponible à partir d’un montant minimum de 100 €.</li>
                <li>La carte cadeau est activée dès l'achat et peut être utilisée immédiatement.</li>
                <li>Elle est valable 24 mois à compter de la date d’achat.</li>
                <li>La carte cadeau est valable sur tous les hébergements de la sélection Hortense.</li>
              </ul>
              <div class="d-flex mt-4 ph-btn-contact" :class="isPhone ? 'd-flex w-100 justify-content-center px-4' : ''">
                <a @click="goToPaymentPage" class="hortense-btn-primary btn-fid mb-4" :class="isPhone ? 'ml-0' : ''">Offrir un séjour en cadeau</a>
              </div>            
            </div>
          </div>
        </section>

        <section id="gift-card-form-container" class="raleway-reg-p15 pr-5 pt-3 mb-4 w-100">
          <div class="d-flex flex-column align-items-center justify-content-center mb-4">
            <div :class="isPhone ? 'merriweather-reg-20 text-center' : 'merriweather-reg-26'">Offrez plus qu'un cadeau</div>
            <div :class="isPhone ? 'merriweather-reg-28 text-center' : 'merriweather-reg-40'">une expérience inoubliable</div>
          </div>

          <div class="row row-one-info align-items-center" data-aos="fade-left" data-aos-duration="1000">
            <div id="gift-card-left" class="col-md-6 d-flex flex-column justify-content-center">
              <p class="custom-font-sub">Offrez bien plus qu'un simple cadeau : offrez une évasion éco-chic au cœur des plus belles régions françaises. Avec la carte cadeau Hortense, vos proches choisissent librement leur prochaine escapade parmi près de 400 hébergements de charme engagés pour un tourisme durable.</p>
              <div class="d-flex justify-content-center w-100" :class="isPhone ? 'px-3' :''">
                <button class="hortense-btn-primary" @click="goToPaymentPage">Offrir une expérience</button>
              </div>
            </div>
            <div class="col-md-6">
              <div class="gift-card-overview">
                <img class="img-fluid w-100" src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/carte_cadeau_img_2.png" v-set-alt />
              </div>
            </div>
          </div>
        </section>
      </div>

      <div id="entreprise-or-ce text-center" class="row main-content pt-5 d-flex justify-content-center" :class="isPhone ? '' : 'padding-x-vous'">
        <div id="picture-enterprise-ce-container" class="col-md-12 col-lg-6" data-aos="fade-left" data-aos-duration="1000">
          <img class="img-fluid" id="o-hortense-entreprise-ce" src="../../images/icotype.svg" v-set-alt data-aos="zoom-out" data-aos-duration="1000">
          <img class="img-fluid mt-0 w-100" id="picture-enterprise-ce" src="../../images/giftcard/enterprise-ce.jpg" v-set-alt>
        </div>
        <div id="description-3" class="col-md-12 col-lg-5 vous-contact" :class="isPhone ? 'pt-3' : ''" data-aos="fade-down " data-aos-duration="1000">
          <h4 :class="isPhone ? 'merriweather-reg-20 text-center' : 'merriweather-reg-26'">Vous êtes une entreprise ou un CE ?</h4>
          <p>Si vous souhaitez remercier vos collaborateurs, fidéliser vos clients ou valoriser vos partenaires à travers des cadeaux porteurs de sens, mêlant élégance et engagement, nous serions ravis de vous accompagner dans la création d’une attention sur-mesure. N’hésitez pas à prendre contact avec nous pour imaginer ensemble une solution parfaitement alignée avec vos valeurs et vos objectifs.</p>
          <div :class="isPhone ? 'w-100 d-flex justify-content-center px-5': 'btn btn-durable border-deb pl-0'">
            <a href="/pages/contact/" class="hortense-btn-primary btn-fid btn-contact" :class="isPhone ? 'ml-0' : ''">NOUS CONTACTER</a>
          </div>            
        </div>
      </div>

      <!--Flash :text='this.text' :status='this.statusFlash' @destroy='toggleStatus(statusFlash)'></Flash-->
      <section class="parr-faq">
        <div class="d-flex flex-column align-items-center justify-content-center">
          <div :class="isPhone ? 'merriweather-reg-20 text-center' : 'merriweather-reg-26'">Questions fréquentes</div>
          <div :class="isPhone ? 'merriweather-reg-28 text-center' : 'merriweather-reg-40'">sur la carte cadeau</div>
        </div>

        <div class="gn-accordion parr-accordion">
          <div v-for="(q,i) in parrFaq" :key="i" class="acc-item">
            <button class="acc-head" @click="toggleAccParr(i)">
              <span class="raleway-semi-p15">{{ q.q }}</span>
              <svg :class="{ open: openFaq.includes(i) }" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M7 10l5 5 5-5" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <transition name="acc">
              <div v-show="openFaq.includes(i)" class="acc-panel">
                <div class="raleway-reg-p15" v-html="q.a"></div>
              </div>
            </transition>
          </div>
        </div>
      </section>
    </div>
  </div>

</template>

<script>
  import headGiftCard from '../../components/giftcards/HeadGiftCard.vue';
  import ScrollUp from "components/btns/ScrollUp.vue";
  import AOS from 'aos';
  import ExperienceCollections from '../gift_boxes/ExperienceCollections.vue';


export default {
  name: 'gift-card',
  components: {
    headGiftCard,
    ScrollUp,
    AOS,
    ExperienceCollections
  },
  props: {
    user: null
  },

  data() {
    return {
      isPhone: window.innerWidth < 768,
      openFaq: [],
      parrFaq: [
      {
        q: "Comment acheter une carte cadeau Hortense ?",
        a: `
          <p>Pour acheter une carte cadeau Hortense :</p>
          <ol>
            <li>Remontez en haut de cette page.</li>
            <li>Cliquez sur le bouton <strong>« Offrir une carte cadeau Hortense »</strong>.</li>
            <li>Choisissez votre montant et laissez-vous guider.</li>
          </ol>
          <p>
            Vous recevez votre carte cadeau directement par email en moins d’une minute
            ou vous pouvez également programmer l’envoi de la carte cadeau au destinataire
            à la date de votre choix.
          </p>
          <p>Si vous avez la moindre question, écrivez-nous à <a style="color: #39423d; font-weight: bold;" href="mailto:customercare@hortense.green">customercare@hortense.green</a>.</p>
        `
      },
      {
        q: "Comment utiliser une carte cadeau Hortense ?",
        a: `
          <ol>
            <li>Saisissez votre code cadeau sur la page de paiement dans la section carte cadeau.</li>
            <li>Choisissez votre séjour parmi tous les hébergements disponibles sur Hortense.</li>
            <li>Finalisez votre réservation : le montant de la carte sera automatiquement déduit. Il ne vous restera plus qu’à profiter !</li>
          </ol>
        `
      },
      {
        q: "Combien de temps ma carte cadeau Hortense est-elle valable ?",
        a: `
          <p>Votre carte cadeau est valable <strong>2 ans à partir de la date d’achat.</strong></p>
          <p>Besoin d’aide ? Contactez-nous : <a style="color: #39423d; font-weight: bold;" href="mailto:customercare@hortense.green">customercare@hortense.green</a></p>
        `
      },
      {
        q: "Puis-je utiliser plusieurs cartes cadeaux pour une même réservation ?",
        a: `
          <p><strong>Non, vous ne pouvez pas cumuler plusieurs cartes cadeaux automatiquement.</strong></p>
          <p>
            En revanche, vous pouvez saisir plusieurs codes un par un lors de la réservation.
            Et si vous préférez disposer d’une seule carte cadeau regroupant le montant total,
            il suffit de nous contacter : nous pouvons en créer une unique pour vous.
          </p>
          <p>
            Contactez-nous : <a style="color: #39423d; font-weight: bold;" href="mailto:customercare@hortense.green">customercare@hortense.green</a>
          </p>
        `
      },
      {
        q: "À quoi donne accès la carte cadeau Hortense ?",
        a: `
          <p>À plus de <strong>350 hébergements engagés partout en France</strong>, soigneusement sélectionnés pour :</p>
          <ul>
            <li><strong>leur impact environnemental maîtrisé</strong>, évalué selon des critères précis,</li>
            <li><strong>la qualité et l’authenticité de l’expérience</strong> qu’ils offrent.</li>
          </ul>
          <p>Vous y trouverez <strong>tous les styles : gîtes, chambres d’hôtes, hébergements insolites, hôtels engagés</strong>, et bien plus encore.</p>
        `
      },
      {
        q: "Comment personnaliser ma carte cadeau Hortense ?",
        a: `
          <p>La carte cadeau Hortense est <strong>100% personnalisable !</strong></p>
          <p>Après avoir choisi le montant, vous pouvez :</p>
          <ul>
            <li>ajouter le prénom du destinataire,</li>
            <li>écrire un message personnalisé.</li>
          </ul>
        `
      },
      {
        q: "À qui offrir une carte cadeau Hortense ?",
        a: `
          <p>À tous ceux qui vous sont chers !</p>
          <p>
            Parents, enfants, partenaire, ami·es…  
            La carte cadeau Hortense, c’est le cadeau idéal pour celles et ceux qui aiment
            <strong>les lieux d’exception</strong>, sont <strong>sensibles au tourisme durable</strong>, recherchent <strong>le confort</strong>,
            et souhaitent voyager autrement.
          </p>
          <p>
            Une invitation à vivre des expériences authentiques et à s’offrir une <strong>évasion
            éco-chic</strong> — et bien sûr, vous pouvez aussi vous faire plaisir 😉
          </p>
        `
      },
      {
        q: "Pourquoi la carte cadeau Hortense est-elle unique ?",
        a: `
          <p>Parce qu’elle permet d’offrir <strong>bien plus qu’un cadeau</strong> :</p>
          - un souvenir durable,</br>
          - des expériences authentiques,</br>
          - un soutien direct aux territoires et aux acteurs du tourisme responsable.</br>
          <p>Offrir une carte Hortense, c’est offrir du sens.</p>
        `
      },
      {
        q: "La carte cadeau Hortense est-elle remboursable ?",
        a: `
          <p>Une fois la commande passée, il n’est plus possible de modifier ou annuler la carte.</p>
        `
      }
    ]
    };
  },

  methods: {
    scrollToElement(div) {
      const el = document.getElementsByClassName(div)[0];

      if (el) {
        el.scrollIntoView();
      }
    },

    goToPaymentPage() {
      window.open('/carte-cadeau/paiement', '_blank');
    },
    toggleAccParr(i) {
      this.openFaq = this.openFaq.includes(i)
        ? this.openFaq.filter(x => x !== i)
        : [...this.openFaq, i];
    },
  },

  mounted(){
    const navbarItems = document.querySelectorAll('.bm-burger-bars');

    navbarItems.forEach((bar) => {
      bar.style.color = 'white';
      bar.style.backgroundColor = 'white';
      bar.style.border = '0.5px solid white';
    });
    AOS.init();
  }
};
</script>

<style lang="scss" scoped>
.why-gift-card{
  display: block;
}
#description-1{
  display: block;
  position: inherit;
  width: 90%;
  margin-top: -15%;
  margin-left: 5%;
  padding-top: 7%;
  padding: 5%;
  background-color: #fff;
}
#picture-enterprise-ce{
  display: block;
  margin-top: 5%;
}
#description-2{
  display: block;
  position: inherit;
  width: 90%;
  margin-top: -15%;
  margin-left: 10%;
  padding: 5%;
  background-color: #fff;
}

#description-3{
  display: block;
  position: inherit;
  width: 90%;
  margin-top: -15%;
  margin-left: 12%;
  padding: 3%;
  background-color: #fff;
}

#sejour{
  .row{
    z-index: -99 !important;
  }
}

#o-hortense-sejour{
  display: flex;
  position: absolute;
  margin-top: -7%;
  margin-left: -7%;
  z-index: 100;
  width: 150px;
}
#o-hortense-pourquoi{
  display: flex;
  position: absolute;
  margin-top: -5%;
  z-index: 100;
  width: 150px;
}
#o-hortense-entreprise-ce{
  display: flex;
  position: absolute;
  margin-top: -10%;
  float:right;
  right: 0;
  margin-right: -10%;
  z-index: 100;
  width: 150px;
}

#o-hortense-experience{
  display: flex;
  position: absolute;
  margin-top: -7%;
  margin-left: -7%;
  z-index: 100;
  width: 150px;
}
#o-hortense-form{
  display: flex;
  position: absolute;
  margin-top: -16%;
  margin-left: -7%;
  z-index: 100;
  width: 300px;
}
#o-hortense-carte-cadeau{
  display: flex;
  position: absolute;
  float: right;
  right: 0;
  margin-top: -23%;
  margin-right: -7%;
  z-index: 100;
  width: 150px;
}

.col-info-form{
  margin-top: 10%;
}

.border-inspect{
  border: 3px solid red !important;
}

#giftcard{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;

  .main-content {
    padding: 4% 8%;
  }

  #section-sejour {

    #sejour {
      z-index: -99;
      .row {
        z-index: -99 !important;
      }
    }
  }
  .phone-add-margin-top{
    padding-top: 2%;
  }

  .card-number{
    float: right;
    transform: rotate(-90deg);
    padding: 0;
    position: absolute;
    right: 0;
  }

  .fs-18{
    font-size: 18px;
  }
  .fs-23{
    font-size: 23px;
  }
  .fs-30{
    font-size: 30px;
  }
  .lh-1{
    line-height: 1.2;
  }

  ul{
    li{
      list-style: none;
      list-style-image: url('../../images/Icotype_puce.svg');
    }
  }
  .raleway-bold-p{
    text-transform: none;
  }
  .border-input{
    border: none;
    border-bottom: 1px solid #ccc;
  }
  .merriweather{
    font-family: Merriweather;    
  }
  .italic{
    font-style: italic;
  }
  .container-giftcard {
    .why-gift-card{
      display: flex;
    }
    #picture-enterprise-ce{
      display: block;
      margin-top: 5%;
    }
    #section-experience{
      margin-top: 5%;
      padding-top: 3%;
      border-top: solid 2px #aba;
    }
    .form-user-info {
      border: 2px solid grey;
      padding: 10px;
    }
  }
}
.gift-card-overview{
  padding-top: 25px;
  display: flex;
  justify-content: center;
}

.text-info-experience{
  background-color: #CFE5DC;
  margin-top: 3rem;
  margin-bottom: 3rem;
  padding: 20px;
}

.p-container{
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1.2;
}

#description-2{
  p{
    font-family: $Raleway;
    margin: 0;
    padding: 0;
  }
}

#description-3{
  p{
    font-family: $Raleway;
    margin: 0;
    padding: 0;
  }
}

#discover-selection{
  display: none;
}
  @media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
    .phone-add-margin-top{
      margin-top: auto 25%;
      width: 100% !important;

      .btn-fid{
        width: 60% !important;
        padding: 2% 0;
        margin: auto 20%;
      }
    }

    .gift-title-form{
      font-size: 14px !important;
      padding: 0 !important;
      margin-left: 0 !important;
      width: 100% !important;
    }

    #description-2{
      h4{
        width: 110% !important;
        margin: auto 20%;
        font-size: 20px;
        margin-bottom: 1rem;
      }
      p{
        margin: 1% 25%;
        padding-right: 10%;
        font-size: 16px !important;
        font-family: $Raleway;
      }
      .ph-btn-contact{
        padding-right: 15%;
      }

    }
    #description-3{
      h4{
        width: 110% !important;
        margin: auto 20%;
        font-size: 20px;
        margin-bottom: 1rem;
      }
      p{
        margin: 1% 25%;
        padding-right: 10%;
        font-size: 16px !important;
        font-family: $Raleway;
      }
      .ph-btn-contact{
        padding-right: 15%;
      }

    }
    .vous-contact{
      text-align: center !important;
    }
    .pourquoi-li{
      width: 100% !important;
      text-align: center;
    }

    .offer-gift-btn{      
      width: 100% !important;
      margin: 0 !important;
    }
    .border-deb{
      margin-left: 1.7rem !important;
    }
    .ph-title{
      font-size: 20px !important;
      width: 110% !important;
      text-align: center !important;         
      font-family: Merriweather, serif !important;
    }

    #section-experience{
      border: none !important;
      .description-experience{
        margin-top: 5%;
        .phone-container-center{          
          margin-left: 2rem;
          width: 80%;
        }        
      }
    }

    #discover-selection{
      display: block;
      margin-bottom: 10%;
    }
    #o-hortense-sejour{
      margin-top: -13%;
      margin-left: 0%;
      z-index: 1 !important;
    }
    #o-hortense-pourquoi{
      margin-top: -16%;
      margin-left: -1%;
    }
    #o-hortense-entreprise-ce{
      margin-top: -16%;
      margin-left: -4%;
      left: 0;
    }
    #o-hortense-experience{
      margin-top: -15%;
      float: right;
      right: 7%;
    }
    #o-hortense-form{
      margin-top: -22%;
      margin-left: -25%;
      width: 155px;
    }
    #o-hortense-carte-cadeau{
      display: none;
    }
    #gift-card-form-container{
      padding: 0 !important;

      #gift-card-left{
        margin-top: 10% !important;
        width: 100% !important;
        .card-number{
          float: right;
          transform: rotate(-90deg);
          padding: 0 !important;
          margin-right: 5px;
          font-size: 8px;
        }
      }
    }
    .form-user-info{
      padding: 10% !important;
      margin-top: 15px !important;
      input, p, label{
        font-size: 10px !important;
      }
      .offer-gift{
        width: 100% !important;
      }
    }

    .text-info-experience{
      width: 100% !important;

    }

    .fs-23{
      text-align: center !important;
      font-size: 18px !important;
    }

    .fs-30{
      margin-left: 15px;
      text-align: center !important;
      font-size: 22px !important;
    }

    .fs-15{
      text-align: center !important;
      font-size: 12px !important;
    }
    #section-sejour{
      text-align: center;

      .sejour-text{
        margin-top: 20px;

        .fs-18{
          font-size: 14px;
        }
      }

      .btn-durable{
        margin-top: 20px;
      }
    }

    #description-1, #description-2, #description-3{
      width: 100% !important;
      margin-top: 0 !important;
      margin-left: 0 !important;

      h5, h4{
        margin-left: -16px;
      }

      ul{
        margin-left: 0 !important;
      }

  .add-btn{
    margin-top: 3rem;
    button {
      display: flex;
    }
    .fs-30{
      margin-left: 15px !important;
      text-align: center !important;
      font-size: 22px !important;
    }
    .fs-15{
      text-align: center !important;
      font-size: 12px !important;
    }
    #section-sejour{
      text-align: center;
      .sejour-text{
        margin-top: 20px;
        .fs-18{
          font-size: 14px;
        }
        .fs-12{
          font-size: 12px !important;
          margin: 0 !important;
        }
      }
      .btn-durable{
        margin-top: 20px;
      }
    }
    #description-1, #description-2, #description-3{
      width: 100% !important;
      margin-top: 0 !important;
      margin-left: 0 !important;
      h5, h4{
        margin-left: -16px;
      }
      .btn-fid{
        margin-left: 15px;
      }
      p{
        width: 100%;
        margin-left: 15px !important;
      }
      .btn-contact{
        width: 100% !important;
      }
    }
    #experience{
      width: 100% !important;
      margin: 0 !important;
      h4{
        text-align: center !important;
      }
      p{
        text-align: center !important;
        margin-left: 15px !important;
      }
      ul{
        text-align: center !important;
      }
    }
  }

      .btn-fid{
        margin-left: 15px;
      }

      p{
        width: 100%;
        margin-left: 15px !important;
      }

      .btn-contact{
        width: 100% !important;
      }
    }

    #experience{
      width: 100% !important;
      margin: 0 !important;

      h4{
        text-align: center !important;
      }

      p{
        font-size: 12px;
        text-align: center !important;
        margin-left: 15px !important;
      }

      ul{
        font-size: 12px;
        text-align: center !important;
      }
    }




  }


  @media screen and (min-width:600px) and (max-width: 1200px){
    #o-hortense-sejour{
      display: flex;
      position: absolute;
      margin-top: -10%;
      margin-left: -10%;
      z-index: 100;
      width: 150px;
    }
    #o-hortense-pourquoi{
      display: flex;
      position: absolute;
      margin-top: -5%;
      z-index: 100;
      width: 150px;
    }
    #o-hortense-entreprise-ce{
      display: flex;
      position: absolute;
      margin-top: -15%;
      float:right;
      right: 0;
      margin-right: -15%;
      z-index: 100;
      width: 150px;
    }
    #o-hortense-experience{
      display: flex;
      position: absolute;
      margin-top: -10%;
      margin-left: -10%;
      z-index: 100;
      width: 150px;
    }
    #o-hortense-form{
      display: flex;
      position: absolute;
      margin-top: -65%;
      margin-left: -7%;
      z-index: 100;
      width: 300px;
    }
    #o-hortense-carte-cadeau{
      display: flex;
      position: absolute;
      float: right;
      right: 0;
      margin-top: -27%;
      margin-right: -10%;
      z-index: 100;
      width: 150px;
    }
  }


  @media screen and (min-width:1200px) and (max-width: 2048px){

     #o-hortense-sejour{
      display: flex;
      position: absolute;
      margin-top: -7%;
      margin-left: -7%;
      z-index: 100;
      width: 150px;
    }
    #o-hortense-pourquoi{
      display: flex;
      position: absolute;
      margin-top: -5%;
      z-index: 100;
      width: 150px;
    }
    #o-hortense-entreprise-ce{
      display: flex;
      position: absolute;
      margin-top: -8%;
      float:right;
      right: 0;
      margin-right: 11%;
      z-index: 100;
      width: 150px;
    }
    #o-hortense-experience{
      display: flex;
      position: absolute;
      margin-top: -7%;
      margin-left: -7%;
      z-index: 100;
      width: 150px;
    }
    #o-hortense-form{
      display: flex;
      position: absolute;
      margin-top: -14%;
      margin-left: -7%;
      z-index: 100;
      width: 300px;
    }
    #o-hortense-carte-cadeau{
      display: flex;
      position: absolute;
      float: right;
      right: 0;
      margin-top: -15%;
      margin-right: -7%;
      z-index: 100;
      width: 150px;
    }

  }

  @media screen and (width > 2048px) {
    #o-hortense-entreprise-ce{
      display: flex;
      position: absolute;
      margin-top: -8%;
      float:right;
      right: 0;
      margin-right: 28%;
      z-index: 100;
      width: 150px;
    }
    #o-hortense-form{
      display: flex;
      position: absolute;
      margin-top: -11%;
      margin-left: -5%;
      z-index: 100;
      width: 300px;
    }

    #o-hortense-carte-cadeau{
      display: flex;
      position: absolute;
      float: right;
      right: 0;
      margin-top: -11%;
      margin-right: -5%;
      z-index: 100;
      width: 150px;
    }
  }

.gn-accordion { background: #f7f6f3; border-radius: 12px; padding: 20px; margin: 28px auto 16px; max-width: 1100px; }
.acc-title { font-size: 1.6rem; text-align: center; margin-bottom: 10px; font-family: Merriweather; }
.acc-item + .acc-item { border-top: 1px solid #dcdcd2; }
.acc-head { width: 100%; background: transparent; border: none; padding: 16px 6px; display: flex; align-items: center; justify-content: space-between; font-weight: 700; color: #2c5c49; cursor: pointer; }
.acc-head svg { transition: transform .25s ease; }
.acc-head svg.open { transform: rotate(180deg); }
.acc-panel { padding: 0 6px 16px 6px; }
.acc-panel ul { margin: 0; font-family: Raleway; padding-left: 18px; }
.acc-panel li { line-height: 1.8; font-family: Raleway; color: #39423d; }
.parr-faq { padding: 36px 0 10px; }
.faq-title { text-align: center; font-size: 30px; line-height: 1.2; }
.faq-title span { font-size: 42px; display:block; margin-top: 6px; }
.parr-accordion { max-width: 1200px; margin: 6px auto 0; }

.parr-bottom {
  --r: 18px;
  margin: 26px auto 0; max-width: 1200px; padding: 0 20px;
}
.parr-bottom__veil {
  background-image: var(--bottom-bg);
  background-size: cover; background-position: center;
  min-height: 210px; border-radius: var(--r);
  display: grid; place-items: center; text-align: center; position: relative; overflow: hidden;
}
.parr-bottom__veil::before {
  content: ""; position: absolute; inset: 0; background: rgba(0,0,0,.35);
}
.parr-bottom__veil > * { position: relative; z-index: 1; }
.bottom-copy { color: #fff; font-size: 1.05rem; line-height: 1.7; max-width: 720px; margin: 0 auto 8px; }

.sr-only { position:absolute; width:1px; height:1px; clip: rect(1px,1px,1px,1px); overflow:hidden; }

@media (max-width: 768px){
  .merri.huge { font-size: 30px; }
  .parr-hero-inner h2 { font-size: 1.6rem; }
  .parr-hero-card { min-height: 220px; }

  .parr-how__grid { grid-template-columns: 1fr; gap: 16px; }
  .parr-card__title { font-size: 1.7rem; }
  .parr-steps li { grid-template-columns: 44px 1fr; }
  .parr-steps .dot { width: 44px; height: 44px; font-size: 1rem; }
  .parr-steps .copy .h { font-size: 1rem; }

  .parr-adv-grid { grid-template-columns: 1fr; }
  .rt-grid { grid-template-columns: 1fr; }
  .faq-title { font-size: 24px; }
  .faq-title span { font-size: 30px; }

  .parr-bottom__veil { min-height: 200px; }
  .acc-head { padding: 10px 0px; text-align: left; }
}

.custom-font-sub {
  font-size: 16px;
  line-height: 25px;
  color: #000000;
  margin-bottom: 0;
  font-family: "Raleway", sans-serif;
  text-align: center;
  margin-bottom: 10px;
  max-width: 100%;
  white-space: normal;
  overflow-wrap: break-word;
  word-break: normal;

  @media screen and (max-width: 768px) {
    margin-top: 10px;
    line-height: 26px;
    text-align: center;
    padding: 0 8px;
  }
}

@media screen and (min-width: 769px) and (max-width: 1100px) {
  #gift-card-form-container {
    .row-one-info {
      align-items: flex-start !important;
    }

    #gift-card-left {
      padding-right: 12px;
    }

    .custom-font-sub {
      font-size: 15px;
      line-height: 24px;
    }

    .gift-card-overview img {
      max-width: 100%;
      height: auto;
      display: block;
    }

    #gift-card-left {
      position: relative;
      z-index: 2;
    }

    .gift-card-overview {
      position: relative;
      z-index: 1;
    }
  }
}

#gift-card-form-container {
  #gift-card-left {
    @media screen and (max-width: 768px) {
      width: 100% !important;
    }
  }

  .gift-card-overview {
    @media screen and (max-width: 768px) {
      width: 100% !important;
      margin-top: 20px !important;
    }
  }

  .row-one-info {
    @media screen and (max-width: 768px) {
      flex-direction: column;
    }
  }
}

@media (max-width: 768px) {
  .full-bleed-phone {
    width: calc(100% + 16%) !important;
    margin-left: -8% !important;
    margin-right: -8% !important;
  }
}
.padding-x-vous {
  padding-left: 12% !important;
  padding-right: 12% !important;
}

// Reassurance grid
.reassurance-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0;
}

.reassurance-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 20px 16px;

  // right column gets a left divider
  &.rg-right {
    border-left: 0.5px solid #ede8e1;
  }

  // top and middle rows get a bottom divider
  &.rg-top,
  &.rg-mid {
    border-bottom: 0.5px solid #ede8e1;
  }
}

.reassurance-icon {
  flex-shrink: 0;
  margin-top: 2px;
  display: flex;
  align-items: flex-start;
}

.reassurance-fa-icon {
  color: #D3AF6C;
  font-size: 24px;
  line-height: 1;
}

.reassurance-title {
  font-size: 14px;
  font-weight: 600;
  color: #2c2c2c;
  margin-bottom: 4px;
  font-family: $Raleway;
  line-height: 1.4;
}

.reassurance-desc {
  font-size: 13px;
  font-weight: 300;
  color: #777;
  line-height: 1.6;
  font-family: $Raleway;
}

@media (max-width: 767px) {
  .reassurance-grid {
    grid-template-columns: 1fr;
  }

  .reassurance-item {
    padding: 16px 8px;

    &.rg-right {
      border-left: none;
      border-top: 0.5px solid #ede8e1;
    }

    &.rg-bottom {
      border-bottom: none;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}
</style>